import { Content } from 'antd/es/layout/layout';
import './ContentComponent.scss';
import { ContactSupport } from '../ContactSupport';
import Dashboard from '../Dashboard/Dashboard';
import AccountSettings from '../Setting/SettingMenu/AccountSettings/AccountSettings';
import ManagePassword from '../Setting/SettingMenu/ManagePassword/ManagePassword';
import { Locale } from '../Setting/SettingMenu/Locale/LocaleForm';
import ManageCredits from '../Setting/SettingMenu/ManageCredits/ManageCredits';
import ManageSubscription from '../Setting/SettingMenu/ManageSubscription/ManageSubscription';
import ManageUsage from '../Setting/SettingMenu/ManageSubscription/ManageUsage';
import { UserAccount } from '@/types/TAccounts';
import { UserDashboardSiderItem } from 'src/enums/EUserDashboardSiderItem';
import TwilioSetup from '@/pages/Novi/pages/Dashboard/Byot/Byot';
import NoviEmail from '@/pages/Novi/pages/Dashboard/Email/NoviEmail';

interface ContentComponentProps {
	currentPage: string;
	loggedInUser: UserAccount;
}

const ContentComponent: React.FC<ContentComponentProps> = ({ currentPage }) => {
	const userLevelContent = (currentPage: string) => {
		switch (currentPage) {
			case UserDashboardSiderItem.SUBSCRIPTION_MANAGEMENT:
				return <ManageSubscription />;
			case UserDashboardSiderItem.SETTINGS:
				return <AccountSettings isLoading={false} />;
			case UserDashboardSiderItem.PASSWORD:
				return <ManagePassword />;
			case UserDashboardSiderItem.PREFERENCES:
				return <Locale />;
			case UserDashboardSiderItem.CREDITS:
				return <ManageCredits />;
			case UserDashboardSiderItem.USAGE:
				return <ManageUsage />;
			case UserDashboardSiderItem.DASHBOARD:
				return <Dashboard />;
			case UserDashboardSiderItem.CONTACT_SUPPORT:
				return <ContactSupport />;
			case UserDashboardSiderItem.OUTBOUND_BYOT:
				return <TwilioSetup resellerView={false} />;
			case UserDashboardSiderItem.OUTBOUND_EMAIL:
				return <NoviEmail />;
			default:
				break;
		}
	};

	const renderContent = () => {
		return userLevelContent(currentPage);
	};

	const baseClass = 'content-component';
	return (
		<Content className={baseClass}>
			<div className={`${baseClass}_content relative`}>{renderContent()}</div>
		</Content>
	);
};

export default ContentComponent;
